<template>
  <div v-if="dataPermission.includes('CNPS_INTEG_EMAIL_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách email gửi cho merchant</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button class="f12 font-medium btn btn-outline-secondary" @click="directionModal = true">
          Hướng dẫn
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.mail"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Tìm kiếm"
            >
              Lọc
            </button>
            <button
              @click="removeForm"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Tìm kiếm"
            >
              Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng email: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataMail"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(sentTime)="data">
                {{ data.item.sentTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(recipient)="data">
                <ul v-for="(item2, index2) in data.item.recipient" :key="index2">
                  <li>{{ item2 }}</li>
                </ul>
              </template>
              <template #cell(recipientCc)="data">
                <ul v-for="(item3, index3) in data.item.recipientCc" :key="index3">
                  <li>{{ item3 }}</li>
                </ul>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button
                    class="dropdown-item"
                    @click="showModalResend(data.item)"
                    v-if="dataPermission.includes('CNPS_INTEG_EMAIL_RESEND')"
                  >
                    Gửi lại
                  </button>
                  <button
                    class="dropdown-item"
                    @click="verify(data.item)"
                    v-if="dataPermission.includes('CNPS_INTEG_EMAIL_RESEND')"
                  >
                    Gửi email tới hòm thư verify
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- Hướng dẫn -->
    <b-modal size="lg" centered v-model="directionModal">
      <template #modal-header="{ close }">
        <h5>Hướng dẫn</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div>
        <b>Xác nhận HĐ hợp tác</b>: Email đầu tiên gửi cho MC để MC xác nhận hợp đồng <br />
        <b>Ký HĐ hợp tác</b>: Email chỉ có khi HĐ là HĐ điện tử doanh nghiệp, hệ thống gửi cho MC để
        ký megadoc <br />
        <b>HĐ hợp tác chấp nhận thanh toán</b>: Hợp đồng được gửi cho MC sau khi được SA duyệt
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="send-email" centered v-model="sendEmailModal" size="lg">
      <template #modal-header="{ close }">
        <h5>Gửi lại email</h5>
        <b-button size="sm" variant="light" @click="close(), (errorMail = '')"> x </b-button>
      </template>
      <div class="form-group row">
        <label for="" class="col-sm-4 col-form-label">Tiêu đề</label>
        <div class="col-sm-8">
          <h6>{{ reSend.subject }}</h6>
        </div>
      </div>

      <div class="form-group row">
        <label for="" class="col-sm-4 col-form-label">Gửi đến</label>
        <div class="col-sm-8">
          <input v-model="reSend.recipient" type="text" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <label for="" class="col-sm-4 col-form-label">CC</label>
        <div class="col-sm-8">
          <input v-model="reSend.recipientCc" type="text" class="form-control" />
        </div>
      </div>
      <p class="text-danger">{{ errorMail }}</p>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="submitSend"> Đồng ý </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { EmailService } from '@/services/email.service'
  import Config from '@/thirdParty/config.js'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'subject', label: 'Tiêu đề email' },
    { key: 'recipient', label: 'Người nhận' },
    { key: 'recipientCc', label: 'CC' },
    { key: 'countResend', label: 'Số lần email được gửi lại' },
    { key: 'sentTime', label: 'TG gửi gần nhất', class: 'text-center' },
    { key: 'status', label: 'Trạng thái', class: 'text-center' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        loading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataMail: [],
        fieldsTable,
        filterTable: fieldsTable,
        optionStatus: Config.statusEmail,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        sendEmailModal: false,
        reSend: {},
        errorMail: '',
        directionModal: false,
      }
    },
    mixins: [prepareQueryParamsMixin],
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    methods: {
      showModalResend(item) {
        this.reSend = {
          ...item,
          recipient: item.recipient.join(', '),
          recipientCc: item.recipientCc.join(', '),
        }
        this.sendEmailModal = true
      },
      async verify(item) {
        const data = await EmailService.reSendEmail({
          id: item.id,
          recipient: ['verify@vimo.vn'],
          recipientCc: [],
        })
        if (data.success) {
          this.successModal('Đã gửi thành công')
        } else {
          this.errorModal(data.message)
        }
      },
      checkMail(email) {
        const listEmailError = []
        const listMailValid = []
        const temp = email.replace(/\s/g, '').split(',')
        const listMail = [...new Set(temp)]
        for (const i in listMail) {
          const regexEmail =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const check = regexEmail.test(String(listMail[i]).toLowerCase())
          if (!check) {
            listEmailError.push(listMail[i])
          } else {
            listMailValid.push(listMail[i])
          }
        }
        return { listEmailError, listMailValid }
      },
      async reSendEmail(p) {
        try {
          this.loading = true
          const data = await EmailService.reSendEmail(p)
          if (data.success) {
            this.successModal('Gửi lại email thành công')
            await this.fetchData()
          } else {
            this.errorModal(data.message)
          }
          this.errorMail = ''
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async submitSend() {
        if (this.reSend.recipient === '') {
          this.errorMail = 'Vui lòng nhập địa chỉ email người nhận'
        } else {
          const checkRecipient = this.checkMail(this.reSend.recipient)
          const checkRecipientCc = this.checkMail(this.reSend.recipientCc)
          const isNotValid = checkRecipient.listEmailError
            .concat(checkRecipientCc.listEmailError)
            .join(', ')
          if (isNotValid !== '') {
            this.errorMail = `Vui lòng kiểm tra lại các địa chỉ email: ${isNotValid}`
          } else {
            this.sendEmailModal = false
            await this.reSendEmail({
              id: this.reSend.id,
              recipient: checkRecipient.listMailValid,
              recipientCc: checkRecipientCc.listMailValid,
            })
          }
        }
      },
      async submitForm(event) {
        event.preventDefault()
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dataMail = []
        this.pagination.total = 0
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.loading = true
          const data = await EmailService.listMail(this.search)
          if (data.success) {
            this.dataMail = data.data.res ? data.data.res : []
            this.pagination.total = data.data.count ? data.data.count : 0
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      successModal(msg) {
        this.notiModal = true
        this.msgNoti = msg
        this.iconNoti = require('@/assets/img/noti-success2.svg')
      },
      errorModal(msg) {
        this.notiModal = true
        this.msgNoti = msg
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      },
    },
  }
</script>

<style></style>
